import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { Item } from "../items/item.entity";
import { BrandsTrims } from "./brands-trims.entity";


@Entity('master_brands')
export class MasterBrand {
  @PrimaryGeneratedColumn("increment", { name: 'master_brand_id' })
  masterBrandId: number;

  @Column("varchar", {
    nullable: false,
    length: 30,
    name: "brand_name"
  })
  masterBrandName: string;
  @Column("varchar", {
    nullable: false,
    length: 60,
    name: "file_path"
  })
  filePath: string;
  @Column("varchar", {
    nullable: false,
    length: 60,
    name: "file_name"
  })
  fileName: string;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_pouch_variant_consider",
    
    })
  isPouchVariantConsider:boolean;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_pouch_bap_no_consider",
    
    })
  isPouchBapNoConsider:boolean;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_pouch_grade_consider",
    
    })
  isPouchGradeConsider:boolean;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_pouch_val_add_one",
    
    })
    isPouchValAddOneConsider:boolean;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_pouch_val_add_two",
    
    })
    isPouchValAddTwoConsider:boolean;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_pouch_val_add_three",
    
    })
    isPouchValAddThreeConsider:boolean;
  
  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_pouch_val_add_four",
    
    })
    isPouchValAddFourConsider:boolean;
  

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_pouch_val_add_five",
    
    })
    isPouchValAddFiveConsider:boolean;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_pouch_foodtype",
    
    })
    isPouchFoodTypeConsider:boolean;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_pouch_product",
    
    })
    isPouchProductConsider:boolean;

 @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_carton_variant_consider",
    
    })
  isCartonVariantConsider:boolean;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_carton_bap_no_consider",
    
    })
  isCartonBapNoConsider:boolean;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_carton_grade_consider",
    
    })
  isCartonGradeConsider:boolean;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_carton_val_add_one",
    
    })
    isCartonValAddOneConsider:boolean;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_carton_val_add_two",
    
    })
    isCartonValAddTwoConsider:boolean;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_carton_val_add_three",
    
    })
    isCartonValAddThreeConsider:boolean;
  
  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_carton_val_add_four",
    
    })
    isCartonValAddFourConsider:boolean;
  

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_carton_val_add_five",
    
    })
    isCartonValAddFiveConsider:boolean;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_carton_foodtype",
    
    })
    isCartonFoodTypeConsider:boolean;

  @Column("boolean",{
    nullable:false,
    default: false,
    name:"is_carton_product",
    
    })
    isCartonProductConsider:boolean;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length: 50
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @OneToMany(type => BrandsTrims, samples => samples.brandsInfo, { nullable: true })
  trimsInfo?: BrandsTrims[];
  @OneToMany(type=>Item, item=>item.brandsInfo)
  itemInfo:Item[];

  @Column("varchar", {
    nullable: false,
    length: 30,
    name: "display_brand_name"
  })
  displayBrandName: string;

}
